module.exports = __webpack_public_path__ + "media/images/forecast-461dfca3a8f3b01758e3e85ffe7353d1.jpg";